import { render, staticRenderFns } from "./TempConfigProjectList.vue?vue&type=template&id=9b52fcac&scoped=true"
import script from "./TempConfigProjectList.vue?vue&type=script&lang=js"
export * from "./TempConfigProjectList.vue?vue&type=script&lang=js"
import style0 from "./TempConfigProjectList.vue?vue&type=style&index=0&id=9b52fcac&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b52fcac",
  null
  
)

export default component.exports